import { createSlice } from "@reduxjs/toolkit";
import { fetchGetUsers } from "../users";
import { DataStatus } from "../../types";

type UsersState = {
  data: Array<User>;
  status: DataStatus;
  error: string | null;
};

const initialState: UsersState = {
  data: [],
  status: DataStatus.idle,
  error: null,
};

export const Slice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetUsers: () => initialState,
    addNewUser: (state, action) => {
      state.data = [action.payload, ...state.data];
      return state;
    },
    updateUser: (state, action) => {
      state.data = state.data.map((user) =>
        user.id === action.payload.id ? { ...user, ...action.payload } : user
      );
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetUsers.pending, (state) => {
        state.status = DataStatus.loading;
        state.error = null;
      })
      .addCase(fetchGetUsers.fulfilled, (state, action) => {
        state.status = DataStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(fetchGetUsers.rejected, (state, action) => {
        state.status = DataStatus.failed;
        state.error = action.error.message ?? "";
      });
  },
});

export default Slice;
